module.exports = __webpack_public_path__ + "static/media/img_30.f12ba78a.png";